import {HttpRequest, HttpResponse} from '@angular/common/http';
import {EventEmitter, Injectable, Optional} from '@angular/core';
import {Value} from '@ng-app-framework/core';
import {Observable} from 'rxjs/Rx';
import {HeaderLoader} from '../HeaderLoader';
import {Callable} from '../Interface/Callable';
import {Requestable} from '../Interface/Requestable';
import {RequestBuilder} from '../RequestBuilder';
import {EndpointConfig} from './EndpointConfig';
export class EndpointCaller implements Callable {

    lastRequest: any                = null;
    lastResponse: HttpResponse<any> = null;

    onApiStart  = new EventEmitter<any>();
    onApiFinish = new EventEmitter<any>();
/**
 * @param {?} http
 * @param {?=} config
 */
constructor(public http: Requestable,
public config: EndpointConfig = {baseUri: ''}) {
    }
/**
 * @param {?} absoluteUrl
 * @param {?} method
 * @param {?=} requestData
 * @return {?}
 */
public call(absoluteUrl: string, method: string, requestData: any = {}): Observable<HttpResponse<any> | any> {
        return this.execute(this.createRequestObject(absoluteUrl, method, requestData));
    }
/**
 * @param {?} path
 * @param {?} method
 * @param {?} requestData
 * @return {?}
 */
protected createRequestObject(path: string, method: string, requestData: any): HttpRequest<any> {
        return new HttpRequest<any>('GET', path).clone(
            this.lastRequest = RequestBuilder.getRequestArgs(
                method, path, requestData
            )
        );
    }
/**
 * @param {?} request
 * @return {?}
 */
protected execute(request: HttpRequest<any>): Observable<HttpResponse<any>> {
        this.onApiStart.emit();
        return this.http.request(request)
                   .finally(() => {
                       this.onApiFinish.emit();
                   })
                   .last()
                   .catch((err, caught) => {
                       return Observable.throw(HeaderLoader.loadFromError(err));
                   })
                   .flatMap((response: HttpResponse<any>) => this.map(response));
    }
/**
 * @param {?} response
 * @return {?}
 */
protected map(response: HttpResponse<any>): Observable<any> {
        this.lastResponse = response;
        return Observable.from([this.transformResponse(this.getObjectFromResponse(response))]);
    }
/**
 * @param {?} response
 * @return {?}
 */
protected getObjectFromResponse(response: HttpResponse<any>): any {
        HeaderLoader.load(response);
        if (Value.hasKey(response || {}, 'body') && Value.isProvided(response.body)) {
            return response.body
        }
        return {};
    }
/**
 * @param {?} response
 * @return {?}
 */
protected transformResponse(response: any): any {
        return response;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Requestable, },
{type: EndpointConfig, decorators: [{ type: Optional }, ]},
];
}

function EndpointCaller_tsickle_Closure_declarations() {
/** @type {?} */
EndpointCaller.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EndpointCaller.ctorParameters;
/** @type {?} */
EndpointCaller.prototype.lastRequest;
/** @type {?} */
EndpointCaller.prototype.lastResponse;
/** @type {?} */
EndpointCaller.prototype.onApiStart;
/** @type {?} */
EndpointCaller.prototype.onApiFinish;
/** @type {?} */
EndpointCaller.prototype.http;
/** @type {?} */
EndpointCaller.prototype.config;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
